import PopupMobile, { PopupMobileRef } from "@/components/common/PopupMobile"
import InputAdult from "@/components/hotel/FormSearch/desktop/InputAdult"
import InputChildren from "@/components/hotel/FormSearch/desktop/InputChildren"
import InputRoom from "@/components/hotel/FormSearch/desktop/InputRoom"
import { Col } from "antd"
import { forwardRef, useImperativeHandle, useRef } from "react"

export type DrawerInputCustomerRoomRef = PopupMobileRef & {

}

export type DrawerInputCustomerRoomProps = {

}

const DrawerInputCustomerRoom = forwardRef<DrawerInputCustomerRoomRef, DrawerInputCustomerRoomProps>((_, ref) => {
  const refPopup = useRef<PopupMobileRef>(null)

  useImperativeHandle(ref, () => ({
    open: () => refPopup.current?.open(),
    close: () => refPopup.current?.close(),
  }), [])

  return (
    <PopupMobile
      ref={refPopup}
      height="min(30rem, 85vh)"
      styles={{ body: { overflowY: "auto", minHeight: 0 } }}
    >
      <Col span={24}>
        <InputAdult />
        <InputChildren />
        <InputRoom />
      </Col>
    </PopupMobile>
  )
})

export default DrawerInputCustomerRoom
